{
    "list": {
        "title": "Lieferscheine",
        "columns": "Spalten"
    },
    "details": {
        "title": "Lieferschein",
        "document": "Lieferscheindokument"
    },
    "columns": {
        "name": "Name",
        "vendor": "Lieferant",
        "dateOfIssue": "Datum",
        "createdBy": "Ersteller:in",
        "linkedTo": "Verlinkt zu",
        "action": "Aktionen"
    },
    "drawer": {
        "editDeliveryNote": "Lieferschein bearbeiten",
        "newDeliveryNote": "Neuer Lieferschein",
        "newDeliveryNoteForPo": "Neuer Lieferschein zu Bestellung #{{ poNumber }}",
        "dnNumber": "Lieferscheinnummer",
        "dateOfIssue": "Datum"
    },
    "states": {
        "DELIVERY_NOTE_DOCUMENT_PENDING": "Dokument ausstehend",
        "DELIVERY_NOTE_DOCUMENT_SUCCESS": "Dokument erhalten",
        "DELIVERY_NOTE_PARTIALLY_LINKED": "Teilweise verknüpft",
        "DELIVERY_NOTE_FULLY_LINKED": "Verknüpft",
        "DELIVERY_NOTE_DELETED": "Gelöscht"
    }
}
